<i18n>
{
  "fr": {
    "baseInputContent": {
      "action": {
        "edit": {
          "label": "Modifier",
          "title": "@:baseInputContent.action.edit.label"
        },
        "delete": {
          "label": "Supprimer",
          "title": "@:baseInputContent.action.delete.label"
        }
      }
    }
  }
}
</i18n>
<template>
  <div class="base-input-content">
    <div class="base-input-content__body">
      <label class="base-input-content__input-group">
        <div
          v-if="$scopedSlots.inputPrepend"
          class="base-input-content__input-group-prepend"
          @click="$emit('prepend-click')"
        >
          <slot name="inputPrepend"></slot>
        </div>

        <div
          v-if="$scopedSlots.main || $scopedSlots.default"
          class="base-input-content__input-wrapper"
        >
          <slot name="main">
            <slot></slot>
          </slot>
        </div>
      </label>

      <div
        v-if="$scopedSlots.actions || allowEdit || allowDelete"
        class="base-input-content__actions"
      >
        <slot name="actions">
          <button
            type="button"
            :title="$t('baseInputContent.action.edit.title')"
            class="base-input-content__action base-input-content__action--edit"
            @click="$emit('edit')"
          >
            <span
              class="base-input-content__action-label"
              v-text="$t('baseInputContent.action.edit.label')"
            ></span>
          </button>
          <button
            type="button"
            :title="$t('baseInputContent.action.delete.title')"
            class="base-input-content__action base-input-content__action--delete"
            @click="$emit('delete')"
          >
            <span
              class="base-input-content__action-label"
              v-text="$t('baseInputContent.action.delete.label')"
            ></span>
          </button>
        </slot>
      </div>
    </div>

    <div v-if="$scopedSlots.after" class="base-input-content__append">
      <slot class="base-input-content__action-label" name="after"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseInputContent',
  props: {
    allowEdit: Boolean,
    allowDelete: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.base-input-content {
  $base-input-content-prepend-width: 2.75rem;
  $base-selector: &;

  &__body {
    display: flex;
    height: 4.125rem;
  }

  &__input-group {
    display: flex;
    flex: 1;
    min-width: 0;
    cursor: pointer;
  }

  &__input-group-prepend {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: $base-input-content-prepend-width;
    min-height: $base-input-content-prepend-width;
  }

  &__input-wrapper {
    flex: 1;
    min-width: 0;
    display: flex;
  }

  &__actions {
    flex: none;
    display: flex;
  }

  &__action {
    border: none;
    font: inherit;
    margin: 0;
    cursor: pointer;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    color: $color-arapawa;
    width: $base-input-content-prepend-width;

    &--edit,
    &--delete {
      &::before {
        @extend %icon;
        display: block;
      }
    }

    &--edit {
      &::before {
        @extend %icon--pen;
      }
    }

    &--delete {
      &::before {
        @extend %icon--trash;
      }
    }
  }

  &__action-label {
    @include sr-only();
  }
}
</style>
